<template>
  <div class="lee-platform-container">
    <el-tabs v-model="active">
      <!-- <el-tab-pane label="抖音" name="douyin">
        <lee-tiktok />
      </el-tab-pane> -->
      <el-tab-pane label="新媒体账号" name="kuaishou">
        <lee-kuaishou />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import LeeTiktok from "./tiktok.vue";
import LeeKuaishou from "./kuaishou.vue";
export default {
  components: {
    LeeTiktok,
    LeeKuaishou,
  },
  data() {
    return {
      active: "kuaishou",
    };
  },
};
</script>
<style lang="less" scoped>
.lee-platform-container {
  background: #fff;
  padding: 24px;
}
</style>
